import { NOTIFICATION_TYPE } from '../../../../constants/common'
import i18n from '../../../../i18n'
import { DocFlowSendingWidgetNotificationType } from '../../DocFlowSending'

import {
  DOC_FLOW_SENDING_COMMUNICATION_SETTINGS_NOTIFICATION_ID_ERROR,
  DOC_FLOW_SENDING_COMMUNICATION_SETTINGS_NOTIFICATION_ID_PERMANENT,
  DOC_FLOW_SENDING_COMMUNICATION_SETTINGS_NOTIFICATION_ID_SUCCESS,
} from './DocFlowSendingCommunicationSettingsWidget.constants'

export function getDocFlowSendingCommunicationSettingsPermanentNotifications() {
  return [
    {
      id: DOC_FLOW_SENDING_COMMUNICATION_SETTINGS_NOTIFICATION_ID_PERMANENT,
      text: i18n.t(
        'DocumentStapling.SendingPhaseCommunicationWidgetNotificationKey'
      ),
      type: NOTIFICATION_TYPE.info,
    },
  ]
}

export function getDocFlowSendingCommunicationSettingsWidgetNotifications(t) {
  return {
    [DocFlowSendingWidgetNotificationType.Error]: {
      id: DOC_FLOW_SENDING_COMMUNICATION_SETTINGS_NOTIFICATION_ID_ERROR,
      text: t(
        'DocumentStapling.SendingPhaseCommunicationWidgetErrorNotificationKey'
      ),
      type: NOTIFICATION_TYPE.error,
    },
    [DocFlowSendingWidgetNotificationType.Success]: {
      id: DOC_FLOW_SENDING_COMMUNICATION_SETTINGS_NOTIFICATION_ID_SUCCESS,
      text: t(
        'DocumentStapling.SendingPhaseCommunicationWidgetSuccessNotificationKey'
      ),
      type: NOTIFICATION_TYPE.success,
    },
  }
}
